import graphqlClient from '~/graphql/graphqlClient';
import type { MutationUnequipItemArgs, EquipItemResult } from 'dt-common/generated/graphql-types';

const mutation = `
mutation UnequipItem(
  $playerId: String!
  $itemId: String!
  $from: ItemLocationInput!
) {
  unequipItem(
    playerId: $playerId
    itemId: $itemId
    from: $from
  ) {
    heroHandle
    target_hero_builds
  }
}
`;

export default async function mutationUnequipItem(
  args: MutationUnequipItemArgs
): Promise<EquipItemResult> {
  return await graphqlClient.request<EquipItemResult>('unequipItem', mutation, args);
}
